var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showRegistration
    ? _c("app-peppol-registration-modal", {
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : !_vm.arePeppolSettingsComplete
    ? _c("app-peppol-complete-settings", {
        on: {
          close: function ($event) {
            return _vm.close()
          },
          finish: function ($event) {
            return _vm.finish()
          },
        },
      })
    : !_vm.useWfPeppol
    ? _c("app-send-via-peppol-modal-billit", {
        attrs: { sale: _vm.sale },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _c("app-send-via-peppol-modal-wf", {
        attrs: { sale: _vm.sale },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }